import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import AdminHeader from './AdminHeader';
import AdminFooter from './AdminFooter';
import AdminSideMenu from './AdminSideMenu';
import AdminMobileNav from './AdminMobileNav';

const AdminLayout: React.FC = () => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="min-vh-100 sb-page-bg d-flex flex-column admin-panel">
      <AdminHeader onOpenSectionsMenu={() => setMobileNavOpen(true)} />
      <AdminMobileNav isOpen={mobileNavOpen} onClose={() => setMobileNavOpen(false)} />
      <div className="container-fluid flex-grow-1 d-flex flex-column px-0">
        <div className="row flex-grow-1 g-0">
          <AdminSideMenu />
          <main className="col-12 col-md-9 ms-md-auto col-lg-10 px-3 px-md-4 py-4 admin-panel-main">
            <Outlet />
          </main>
        </div>
      </div>
      <AdminFooter />
    </div>
  );
};

export default AdminLayout;
